import React, { useState, useEffect, useContext } from 'react';
import { Icon } from '@amzn/awsui-components-core';

import CommunityCollectionCtx from './CommunityCollectionCtx';
import { FilterCategory } from '../../content/ContentFilters';
const emptyHeartSvgPath = '/images/heart-empty.svg';

interface Props {
  filterType: FilterCategory;
}

const CollectionFilterSlicer = ({ filterType }: Props) => {
  const { filterOptions, setFilterOptions } = useContext(CommunityCollectionCtx);
  const [selected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    const filterValue = filterType;
    const filterSection = filterOptions?.[filterValue];
    if (selected) {
      // @ts-expect-error TS18048 - strict migration
      if (filterSection.options[filterValue]) {
        if (
          // @ts-expect-error TS18048 - strict migration
          filterSection.options[filterValue].selected !== undefined &&
          // @ts-expect-error TS18048 - strict migration
          selected !== filterSection.options[filterValue].selected
        ) {
          // @ts-expect-error TS18048 - strict migration
          setSelected(filterSection.options[filterValue].selected);
        }
      } else {
        const emptyFilterOption = {
          count: 0,
          label: filterValue,
          selected: false,
          value: filterValue,
        };
        // @ts-expect-error TS18048 - strict migration
        filterSection.options[filterValue] = emptyFilterOption;
        setFilterOptions({ ...filterOptions });
      }
    }
  }, [filterOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSlicerClick = () => {
    const selectedOption = !selected;
    const filterValue = filterType;
    const filterSection = filterOptions?.[filterValue];
    // @ts-expect-error TS18048 - strict migration
    if (filterSection.options[filterValue]) {
      // @ts-expect-error TS18048 - strict migration
      filterSection.options[filterValue].selected = selectedOption;
    } else {
      const emptyFilterOption = {
        count: 0,
        label: filterValue,
        selected: selectedOption,
        value: filterValue,
      };
      // @ts-expect-error TS18048 - strict migration
      filterSection.options[filterValue] = emptyFilterOption;
    }
    setFilterOptions({ ...filterOptions });
    setSelected(selectedOption);
  };

  const className = selected ? 'filter-badge-selected' : 'filter-badge-not-selected';
  return (
    <button className={`filter-badge ${className}`} onClick={handleSlicerClick}>
      <Icon url={emptyHeartSvgPath} alt="Heart" />
      &nbsp;Favorites
    </button>
  );
};

export default CollectionFilterSlicer;
